export const GetHoursString = (hours: number) => {
  return hours === 1 ? 'hour' : 'hours'
}
